export var adjustAntdProps = function adjustAntdProps(props, options) {
  options.forEach(function (option) {
    var targetProp = option.targetProp,
        shouldOverride = option.shouldOverride,
        override = option.override,
        _option$alwaysOverrid = option.alwaysOverride,
        alwaysOverride = _option$alwaysOverrid === void 0 ? false : _option$alwaysOverrid;
    var originProp = props[targetProp]; // 根据条件判断是否需要override

    if (shouldOverride) {
      // 当原始属性是undefined或者标记为alwaysOverride时，覆盖属性
      if (originProp === undefined || alwaysOverride) {
        props[targetProp] = override;
      }
    }
  });
  return props;
};
//# sourceMappingURL=utils.js.map